<nav class="navbar">
  <div class="navbar-content">
    <div class="navbar-left">
      <div class="flex items-center gap-3">
        <p-button
          *ngIf="isMobile"
          icon="pi pi-bars"
          [text]="true"
          (onClick)="toggleSidebar()"
          class="menu-toggle"
        />
        <div class="h-10 w-10 relative" *ngIf="logoUrl()">
          <img [ngSrc]="logoUrl()!" alt="Logo workspace" class="object-cover rounded" fill/>
        </div>
        <span class="font-medium workspace-name truncate">{{ userWorkspace() }}</span>
        @if (isOwner()) {
          <p-menu
            #workspaceMenu
            [popup]="true"
            [model]="workspaceActions()"
            [appendTo]="'body'"
          ></p-menu>
          <p-button
            icon="pi pi-ellipsis-h"
            [rounded]="true"
            [text]="true"
            (onClick)="workspaceMenu.toggle($event)"
          ></p-button>
        }
      </div>
    </div>

    <div class="navbar-right">
      <div class="avatar-container">
        <p-avatar
          [label]="userAvatarLabel"
          size="normal"
          shape="circle"
          (click)="toggleAvatarMenu($event, avatarMenu)"
          class="user-avatar"
        />
        <p-menu [model]="avatarItems()" [popup]="true" #avatarMenu [appendTo]="'body'"></p-menu>
      </div>
    </div>
  </div>
</nav>
